import React from 'react'

import NavigationMenuItem from "../../../menu-items/menu-item"
import NavigationMenuItemCustomView from "../../../menu-items/custom-view/menu-item-custom-view"
// @ts-ignore
import NavigationMenuItemPortfolio from "../../../menu-items/portfolio/menu-item-portfolio";

export default function NavigationMenuProjectsViewsItem(props:any) {

    switch (props.item.type) {
        case 'all'      : return <NavigationMenuItem {...props}
                                                     name="All projects"
                                                     icon="i5-projects-list"
                                                     onClick={()=>{gd.goTo('o/'+gd.companyId+'/projects')}}/>
        case 'view'     : return <NavigationMenuItemCustomView {...props} viewId={props.item.data.id} />
        case 'portfolio': return <NavigationMenuItemPortfolio {...props} portfolio={props.item.data}/>
        default:
            return null
    }
}
